import { Button } from '@material-ui/core';
import { useStyles } from '@webapps/styles';
import { useState } from 'react';

const TextFieldButtonIcon = ({ label, placeholder, type = 'text', icon, buttonLabel, onButtonClick, onChange }) => {
  const {
    classes,
    theme: { spacing },
  } = useStyles(styles);

  const [value, setValue] = useState('');

  const handleChange = (event) => {
    setValue(event.target.value); // Update local state
    if (onChange) {
      onChange(event); // Call the passed onChange prop
    }
  };

  return (
    <div className={classes.container}>
      <div
        className={classes.startIcon}
        style={{
          color: value ? '#152652' : '#92ABD2',
        }}
      >
        {icon}
      </div>
      <input
        type={type}
        placeholder={placeholder}
        className={classes.input}
        value={value}
        onChange={handleChange}
      />
      <Button className={classes.endButton} onClick={onButtonClick}>
        {buttonLabel}
      </Button>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    width: '100%',

    '&:hover': {
      '& svg': {
        color: '#0060F9',
      },
      '& input': {
        borderColor: '#0060F9',
        '&::placeholder': {
          color: '#0060F9',
        },
        color: '#0060F9 !important',
      },
    },
  },
  input: {
    width: '100%',
    height: '50px',
    borderRadius: '400px',
    color: '#152652',
    border: '1px solid #C0D9FF',
    padding: `${spacing(1)}px ${spacing(18)}px ${spacing(1)}px ${spacing(6)}px`,
    fontSize: '13.5px',
    '&:focus': {
      outline: 'none',
      borderColor: '#2196F3',
    },
    '&::placeholder': {
      color: '#92ABD2',
    },
  },
  startIcon: {
    position: 'absolute',
    left: 14,
    top: '50%',
    transform: 'translateY(-50%)',
    display: 'flex',
    alignItems: 'center',
    color: '#92ABD2',
  },
  endButton: {
    position: 'absolute',
    right: 14,
    top: '50%',
    transform: 'translateY(-50%)',
    backgroundColor: '#0060F9',
    color: '#FFFFFF',
    fontSize: '13.5px',
    borderRadius: '40px',
    border: 'none',
    cursor: 'pointer',
    padding: '0px 15px',
    height: 'min-content',
    fontWeight: 500,
    height: '30px',
    '&:hover': {
      backgroundColor: '#004AC1',
    },
  },
});

export default TextFieldButtonIcon;